import {useMutation} from "@tanstack/react-query";
import {createClaim} from "../services/ClaimService";

export function useClaimCreate() {
    return useMutation({
        mutationFn: createClaim,
    });
}
